module.exports = __webpack_public_path__ + "img/up-arrow.c776a2b7.svg";